require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.freeze");

function n(n) {
  return n && "object" == typeof n && "default" in n ? n["default"] : n;
}

var e = require("styled-components"),
    r = n(e),
    t = require("react"),
    o = n(t),
    a = n(require("prop-types")),
    i = Object.freeze(["\n  border-radius: var(--border-radius);\n  display: inline-block;\n  overflow: hidden;\n  line-height: 1;\n  vertical-align: middle;\n\n  object-fit: cover;\n"]),
    l = r.img(i);

var s = Object.freeze(["\n  border: 0;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  user-select: none;\n  display: inline-block;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  white-space: nowrap;\n  vertical-align: middle;\n\n  padding: 6px 12px;\n  line-height: 20px;\n  font-size: var(--font-size-medium);\n\n  background-color: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  color: var(--text-black);\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &[disabled] {\n    cursor: default;\n    opacity: 0.4;\n  }\n\n  & + & {\n    margin-left: 5px;\n  }\n\n  > i {\n    font-style: normal;\n    font-weight: var(--font-weight-semibold);\n    opacity: .75;\n  }\n\n  > svg {\n    vertical-align: text-top;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]),
    c = {
  primary: "\n    background-color: var(--bg-green);\n    border-color: var(--border-green);\n    color: var(--text-white);\n\n    &:focus {\n      box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075),\n        0 0 0 0.2em rgba(101, 124, 251, 0.33);\n    }\n  ",
  secondary: "\n    background-color: var(--bg-blue);\n    border-color: var(--border-blue);\n    color: var(--text-white);\n\n    &:focus {\n      box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075),\n        0 0 0 0.2em rgba(101, 124, 251, 0.33);\n    }\n  ",
  small: "\n    padding: 3px 10px;\n    font-size: var(--font-size-small);\n  ",
  large: "\n    padding: 0.8rem 1rem;\n    font-size: var(--font-size-default);\n  ",
  fullWidth: "\n    display: block;\n    width: 100%;\n    text-align: center;\n  ",
  link: "\n    background: 0;\n    border: 0;\n    color: var(--text-blue);\n    cursor: pointer;\n    font-size: inherit;\n    font-weight: normal;\n    padding: 0;\n    outline: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  "
},
    d = r(function (n) {
  var e = n.as;
  void 0 === e && (e = "button");

  var r = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["as", "color", "fullWidth", "size", "variant"]);

  return o.createElement(e, r);
})(s, function (n) {
  return n.color && c[n.color];
}, function (n) {
  return "link" !== n.variant && n.size && c[n.size];
}, function (n) {
  return n.fullWidth && c.fullWidth;
}, function (n) {
  return n.variant && c[n.variant];
});
d.propTypes = {
  children: a.node.isRequired,
  color: a.oneOf(["inherit", "primary", "secondary"]),
  disabled: a.bool,
  fullWidth: a.bool,
  variant: a.oneOf(["link"]),
  size: a.oneOf(["small", "large"])
};
var p = Object.freeze(["\n  padding: var(--spacer-3);\n  border-bottom: 1px solid var(--border-gray);\n  display: block;\n\n  &:first-child {\n    border-top-left-radius: var(--border-radius);\n    border-top-right-radius: var(--border-radius);\n  }\n\n  &:last-child {\n    border-bottom-color: transparent;\n    border-bottom-left-radius: var(--border-radius);\n    border-bottom-right-radius: var(--border-radius);\n  }\n\n  &[href] {\n    text-decoration: none;\n  }\n  &[href]:hover {\n    background-color: var(--bg-gray);\n  }\n"]),
    b = Object.freeze(["\n  padding: var(--spacer-3);\n"]),
    f = Object.freeze(["\n  border-bottom: 1px solid var(--border-gray);\n  padding: var(--spacer-3);\n  background-color: var(--bg-gray);\n  border-top-left-radius: var(--border-radius);\n  border-top-right-radius: var(--border-radius);\n"]),
    u = Object.freeze(["\n  background-color: white;\n  border: 1px solid var(--border-gray);\n  border-radius: var(--border-radius);\n"]),
    g = r.div(u);
g.Header = r.div(f), g.Body = r.div(b), g.Row = r.div(p);
var m = Object.freeze(["\n  border: 5px solid;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n\n  display: inline-block;\n  width: 0;\n  height: 0;\n  vertical-align: text-bottom;\n  margin: 0 5px;\n"]),
    h = Object.freeze(["\n  height: 1px;\n  margin: 8px 1px;\n  background-color: #e1e4e8;\n"]),
    v = Object.freeze(["\n  border-radius: 0;\n  display: block;\n  padding: 5px 10px 5px 15px;\n  overflow: hidden;\n  color: var(--text-black);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: none;\n\n  &:hover {\n    background-color: var(--bg-blue);\n    color: var(--text-white);\n    text-decoration: none;\n  }\n"]),
    x = Object.freeze(["\n  --width: 180px;\n\n  background-color: #fff;\n  border: 1px solid rgba(27, 31, 35, 0.15);\n  border-radius: var(--border-radius);\n  box-shadow: 0 3px 12px rgba(27,31,35,0.15);\n  font-size: var(--font-size-medium);\n  padding-top: 5px;\n  padding-bottom: 5px;\n  margin-top: 12px;\n\n  position: absolute;\n  top: 100%;\n  left: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: var(--width);\n  z-index: 100;\n\n  will-change: transform, opacity;\n  animation: ", ' 0.15s cubic-bezier(0.2, 0, 0.13, 1.5);\n\n  &::before {\n    --size: 14px;\n\n    content: "";\n    display: block;\n    width: var(--size);\n    height: var(--size);\n    background: #fff;\n\n    transform: rotate(45deg) translate(6px, 6px);\n    box-shadow: -1px -1px 1px -1px rgba(0, 0, 0, .54);\n\n    position: absolute;\n    left: calc(50% - (var(--size) / 2));\n    bottom: 100%;\n\n    z-index: -1;\n  }\n\n  > ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n']),
    z = Object.freeze(['\n  display: inline-block;\n  position: relative;\n\n  > summary {\n    cursor: pointer;\n  }\n\n  > summary:focus {\n    outline: 0;\n  }\n\n  /*  Remove marker added by Chrome */\n  > summary::-webkit-details-marker {\n    display: none;\n  }\n\n  /* Overlay to blur details */\n  &[open] > summary::before {\n    content: "";\n    cursor: default;\n    display: block;\n\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n']),
    y = Object.freeze(["\n  0% {\n    opacity: 0;\n    transform: translateX(-50%) scale(0.5);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(-50%) scale(1);\n  }\n"]),
    w = e.keyframes(y),
    O = r.details(z);
O.Menu = r.div(x, w), O.Item = r.div(v), O.MenuDivider = r.div(h), O.Arrow = r.span(m);

var k = Object.freeze(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]),
    j = function j(n) {
  return n || 0 === n;
},
    C = r.div(k, function (n) {
  return n.alignContent ? "align-content: " + n.alignContent + ";" : "";
}, function (n) {
  return n.alignSelf ? "align-self: " + n.alignSelf + ";" : "";
}, function (n) {
  return n.alignItems ? "align-items: " + n.alignItems + ";" : "";
}, function (n) {
  return n.display ? "display: " + n.display + ";" : "";
}, function (n) {
  return j(n.flex) ? "flex: " + n.flex + ";" : "";
}, function (n) {
  return j(n.flexBasis) ? "flex-basis: " + n.flexBasis + ";" : "";
}, function (n) {
  return n.flexDirection ? "flex-direction: " + n.flexDirection + ";" : "";
}, function (n) {
  return j(n.flexGrow) ? "flex-grow: " + n.flexGrow + ";" : "";
}, function (n) {
  return j(n.flexShrink) ? "flex-shrink: " + n.flexShrink + ";" : "";
}, function (n) {
  return n.flexWrap ? "flex-wrap: " + n.flexWrap + ";" : "";
}, function (n) {
  return j(n.height) ? "height: " + n.height + ";" : "";
}, function (n) {
  return n.justifyContent ? "justify-content: " + n.justifyContent + ";" : "";
}, function (n) {
  return j(n.margin) ? "margin: " + n.margin + ";" : "";
}, function (n) {
  return j(n.marginBottom) ? "margin-bottom: " + n.marginBottom + ";" : "";
}, function (n) {
  return j(n.marginLeft) ? "margin-left: " + n.marginLeft + ";" : "";
}, function (n) {
  return j(n.marginRight) ? "margin-right: " + n.marginRight + ";" : "";
}, function (n) {
  return j(n.marginTop) ? "margin-top: " + n.marginTop + ";" : "";
}, function (n) {
  return j(n.maxHeight) ? "max-height: " + n.maxHeight + ";" : "";
}, function (n) {
  return j(n.maxWidth) ? "max-width: " + n.maxWidth + ";" : "";
}, function (n) {
  return j(n.minHeight) ? "min-height: " + n.minHeight + ";" : "";
}, function (n) {
  return j(n.minWidth) ? "min-width: " + n.minWidth + ";" : "";
}, function (n) {
  return j(n.order) ? "order: " + n.order + ";" : "";
}, function (n) {
  return j(n.padding) ? "padding: " + n.padding + ";" : "";
}, function (n) {
  return j(n.paddingBottom) ? "padding-bottom: " + n.paddingBottom + ";" : "";
}, function (n) {
  return j(n.paddingLeft) ? "padding-left: " + n.paddingLeft + ";" : "";
}, function (n) {
  return j(n.paddingRight) ? "padding-right: " + n.paddingRight + ";" : "";
}, function (n) {
  return j(n.paddingTop) ? "padding-top: " + n.paddingTop + ";" : "";
}, function (n) {
  return j(n.width) ? "width: " + n.width + ";" : "";
});

C.propTypes = {
  alignContent: a.oneOf(["center", "flex-end", "flex-start", "space-around", "space-between", "stretch"]),
  alignItems: a.oneOf(["baseline", "center", "flex-end", "flex-start", "stretch"]),
  alignSelf: a.oneOf(["baseline", "center", "flex-end", "flex-start", "stretch"]),
  children: a.node,
  display: a.oneOf(["flex", "inline-flex"]),
  flex: a.oneOfType([a.string, a.number]),
  flexBasis: a.oneOfType([a.string, a.number]),
  flexDirection: a.oneOf(["column-reverse", "column", "row-reverse", "row"]),
  flexGrow: a.oneOfType([a.string, a.number]),
  flexShrink: a.oneOfType([a.string, a.number]),
  flexWrap: a.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  height: a.oneOfType([a.string, a.number]),
  inline: a.bool,
  justifyContent: a.oneOf(["center", "flex-end", "flex-start", "space-around", "space-between"]),
  margin: a.oneOfType([a.string, a.number]),
  marginBottom: a.oneOfType([a.string, a.number]),
  marginLeft: a.oneOfType([a.string, a.number]),
  marginRight: a.oneOfType([a.string, a.number]),
  marginTop: a.oneOfType([a.string, a.number]),
  maxHeight: a.oneOfType([a.string, a.number]),
  maxWidth: a.oneOfType([a.string, a.number]),
  minHeight: a.oneOfType([a.string, a.number]),
  minWidth: a.oneOfType([a.string, a.number]),
  order: a.number,
  padding: a.oneOfType([a.string, a.number]),
  paddingBottom: a.oneOfType([a.string, a.number]),
  paddingLeft: a.oneOfType([a.string, a.number]),
  paddingRight: a.oneOfType([a.string, a.number]),
  paddingTop: a.oneOfType([a.string, a.number]),
  style: a.object,
  width: a.oneOfType([a.string, a.number])
}, C.defaultProps = {
  display: "flex"
};
var L = Object.freeze(["\n  margin: ", " 0;\n"]),
    M = r.div(L, function (n) {
  return n.spacing;
});
M.propTypes = {
  spacing: a.string
}, M.defaultProps = {
  spacing: "15px"
};
var H = Object.freeze(["\n  display: inline-block;\n  font-size: var(--font-size-medium);\n  font-weight: 600;\n  margin-bottom: 6px;\n\n  > small {\n    color: var(--text-gray);\n    font-weight: 400;\n  }\n"]),
    T = r.label(H),
    V = Object.freeze(["\n    @media (min-width: ", "em) {\n      ", ";\n    }\n  "]),
    S = {
  small: 376,
  medium: 768,
  large: 992
},
    E = Object.keys(S).reduce(function (n, r) {
  var t = S[r] / 16;
  return n[r] = function () {
    for (var n = [], r = arguments.length; r--;) {
      n[r] = arguments[r];
    }

    return e.css(V, t, e.css.apply(void 0, n));
  }, n;
}, {});
var I = Object.freeze(["\n    grid-template-columns: ", ";\n  "]),
    B = Object.freeze(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: ", ";\n  align-items: ", ";\n\n  ", ";\n"]),
    P = r(function (n) {
  var e = n.as;
  void 0 === e && (e = "div");

  var r = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["as", "templateColumns", "gap", "alignItems"]);

  return o.createElement(e, r);
})(B, function (n) {
  return n.gap;
}, function (n) {
  return n.alignItems;
}, E.medium(I, function (n) {
  return n.templateColumns;
}));
P.propTypes = {
  templateColumns: a.string.isRequired,
  gap: a.string,
  alignItems: a.oneOf(["start", "end", "center", "stretch"])
}, P.defaultProps = {
  gap: "25px 15px"
};
var D = {
  check: {
    size: 24,
    path: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  },
  close: {
    size: 24,
    path: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  },
  link: {
    size: 24,
    path: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
  },
  thumbUp: {
    size: 24,
    path: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"
  },
  thumbDown: {
    size: 24,
    path: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
  },
  expandMore: {
    size: 24,
    path: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  },
  expandLess: {
    size: 24,
    path: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
  },
  info: {
    size: 24,
    path: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  },
  help: {
    size: 24,
    path: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
  },
  send: {
    size: 24,
    path: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
  },
  clear: {
    size: 24,
    path: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  },
  share: {
    size: 24,
    path: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
  },
  fileDownload: {
    size: 24,
    path: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
  },
  key: {
    size: 24,
    path: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  },
  description: {
    size: 24,
    path: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
  },
  work: {
    size: 24,
    path: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
  },
  school: {
    size: 24,
    path: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
  },
  language: {
    size: 24,
    path: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
  },
  chart: {
    size: 24,
    path: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
  },
  history: {
    size: 24,
    path: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
  },
  business: {
    size: 24,
    path: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
  },
  code: {
    size: 24,
    path: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
  },
  people: {
    size: 24,
    path: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
  },
  sync: {
    size: 24,
    path: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
  },
  edit: {
    size: 24,
    path: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  },
  preview: {
    size: 24,
    path: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
  },
  location: {
    size: 24,
    path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
  },
  supervisor: {
    size: 24,
    path: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
  },
  money: {
    size: 24,
    path: "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
  }
};

var W = function W(n) {
  var e = n.name,
      r = n.size,
      t = n.color,
      a = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["name", "size", "color"]);

  return D[e] ? o.createElement("svg", Object.assign({}, {
    fill: t,
    height: r,
    viewBox: "0 0 " + D[e].size + " " + D[e].size,
    width: r
  }, a, {
    xmlns: "http://www.w3.org/2000/svg"
  }), o.createElement("path", {
    d: D[e].path
  })) : (console.log('Icon "' + e + '" does not exist :('), null);
};

W.propTypes = {
  name: a.string.isRequired,
  size: a.number,
  color: a.string
}, W.defaultProps = {
  size: 16,
  color: "currentColor"
};
var R = Object.freeze(["\n    padding-left: 20px;\n    padding-right: 20px;\n  "]),
    X = Object.freeze(["\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n\n  ", ";\n\n  /* Set the layout type */\n  ", ";\n"]),
    A = {
  small: "\n    max-width: 480px;\n  ",
  narrow: "\n    max-width: 740px;\n  ",
  "default": "\n    max-width: 1040px;\n  ",
  wide: "\n    max-width: 1200px;\n  "
},
    F = r.div(X, E.medium(R), function (n) {
  return A[n.layout];
});
F.propTypes = {
  layout: a.PropTypes.oneOf(Object.keys(A))
}, F.defaultProps = {
  layout: "default"
};

var q = Object.freeze(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  z-index: 10;\n  background: #22d3a6;\n  transform: translateX(100%);\n  animation: ", " 1s ease-in-out infinite;\n"]),
    G = Object.freeze(["\n  0% {\n    transform: translateX(-100%)\n  }\n\n  40% {\n    transform: translateX(0)\n  }\n\n  60% {\n    transform: translateX(0)\n  }\n\n  100% {\n    transform: translateX(100%)\n  }\n"]),
    U = e.keyframes(G),
    N = r.div.attrs({
  role: "progressbar",
  "aria-label": "Loading…"
})(q, U),
    _ = Object.freeze(["\n  background-color: var(--bg-purple-light);\n  border-bottom: 1px solid var(--border-gray);\n  color: var(--text-purple);\n  font-size: var(--font-size-medium);\n  padding: var(--spacer-4) 0;\n"]),
    J = r.div(_),
    K = Object.freeze(["\n  background-color: var(--bg-white);\n  border: 1px solid var(--border-gray);\n  color: var(--text-gray-dark);\n  display: inline-block;\n  padding: 6px 14px;\n  line-height: 20px;\n  font-weight: 600;\n\n  & + & {\n    border-left: 0;\n  }\n\n  &:hover {\n    background-color: var(--bg-gray);\n    text-decoration: none;\n  }\n\n  &.active {\n    background-color: #0060ea;\n    border-color: #0060ea;\n    color: white;\n  }\n\n  &:first-child {\n    border-top-left-radius: var(--border-radius);\n    border-bottom-left-radius: var(--border-radius);\n  }\n\n  &:last-child {\n    border-top-right-radius: var(--border-radius);\n    border-bottom-right-radius: var(--border-radius);\n  }\n"]),
    Q = Object.freeze(["\n\n"]),
    Y = r.nav(Q);

Y.Item = r.a(K);

var Z = Object.freeze(["\n    font-size: var(--font-size-medium);\n  "]),
    $ = Object.freeze(["\n  appearance: none;\n  background-color: var(--bg-gray-light);\n  border: 1px solid var(--border-gray);\n  border-radius: 3px;\n  padding: 0.6rem 0.8rem;\n  width: 100%;\n  resize: none;\n\n  /* 16px to prevent iOS zoom-on-focus */\n  font-size: var(--font-size-default);\n\n  ", ";\n\n  &:focus {\n    background-color: var(--bg-white);\n    outline: 0;\n    border-color: var(--border-blue);\n    box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075),\n      0 0 0 0.2em rgba(0, 96, 234, 0.33);\n  }\n\n  &[disabled] {\n    color: var(--text-gray);\n  }\n"]),
    nn = r.input($, E.medium(Z)),
    en = nn.withComponent("textarea"),
    rn = function (n) {
  function e(e) {
    n.call(this, e), this.state = {
      value: this.props.value,
      id: Array.from(new Array(6), function () {
        return (~~(36 * Math.random())).toString(36);
      }).join("")
    };
  }

  return n && (e.__proto__ = n), (e.prototype = Object.create(n && n.prototype)).constructor = e, e.prototype.saveToState = function (n) {
    var e,
        r = n.target,
        t = r.name,
        o = r.value;
    this.setState(((e = {})[t] = o, e)), "function" == typeof this.props.onChange && this.props.onChange(n, {
      name: t,
      value: o
    });
  }, e.prototype.render = function () {
    var n = this,
        e = this.props,
        r = e.label,
        a = e.hint,
        i = e.rows,
        l = function (n, e) {
      var r = {};

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
      }

      return r;
    }(e, ["label", "hint", "rows"]),
        s = i ? en : nn;

    return o.createElement(t.Fragment, null, o.createElement(T, {
      htmlFor: this.state.id
    }, r), o.createElement(s, Object.assign({}, {
      rows: i,
      onChange: function onChange(e) {
        return n.saveToState(e);
      },
      value: this.state.value,
      id: this.state.id
    }, l)), a && o.createElement("p", {
      style: {
        color: "var(--text-gray)",
        fontSize: "var(--font-size-small)",
        margin: "4px 0 2px"
      }
    }, a));
  }, e;
}(t.PureComponent);

rn.propTypes = {
  value: a.string,
  rows: a.string,
  hint: a.string,
  onChange: a.func
};
var tn = {
  top: "\n    &:before {\n      top: -7px;\n      right: 50%;\n      bottom: auto;\n      margin-right: -6px;\n      border-top-color: #1b1f23\n    }\n\n    &:after {\n      right: 50%;\n      bottom: 100%;\n      margin-bottom: 6px;\n      transform: translateX(50%);\n    }\n  ",
  bottom: "\n    &:before {\n      top: auto;\n      right: 50%;\n      bottom: -7px;\n      margin-right: -6px;\n      border-bottom-color: #1f2228;\n    }\n\n    &:after {\n      top: 100%;\n      right: 50%;\n      margin-top: 6px;\n      transform: translateX(50%);\n    }\n  ",
  topLeft: "\n    &:after {\n      right: 50%;\n      bottom: 100%;\n      margin-right: -16px;\n      margin-bottom: 6px;\n    }\n\n    &:before {\n      top: -7px;\n      right: 50%;\n      bottom: auto;\n      margin-right: -6px;\n      border-top-color: #1b1f23;\n    }\n  "
};

var on = Object.freeze(["\n  display: inline-block;\n  position: relative;\n\n  &:before,\n  &:after {\n    display: none;\n    opacity: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:before {\n    border: 6px solid transparent;\n    content: '';\n    width: 0;\n    height: 0;\n    z-index: 1000001;\n  }\n\n  &:after {\n    background: #1f2228;\n    border-radius: 3px;\n    color: white;\n    content: attr(aria-label);\n    font-size: var(--font-size-small);\n    font-weight: normal;\n    line-height: 1.5;\n    text-align: center;\n    padding: 0.5em 0.75em;\n    z-index: 1000000;\n    -webkit-font-smoothing: subpixel-antialiased;\n\n    /* multiline support */\n    width: max-content;\n    max-width: 250px;\n    word-wrap: break-word;\n    white-space: pre-line;\n    border-collapse: separate;\n  }\n\n  &:hover:before,\n  &:hover:after,\n  &:active:before,\n  &:active:after,\n  &:focus:before,\n  &:focus:after {\n    display: inline-block;\n    animation-name: ", ";\n    animation-duration: 0.1s;\n    animation-fill-mode: forwards;\n    animation-timing-function: ease-in;\n    animation-delay: 0.4s;\n  }\n\n  > svg {\n    vertical-align: middle;\n  }\n\n  /* Apply position specific props at the end to keep specifity */\n  ", ";\n"]),
    an = Object.freeze(["\nfrom {\n      opacity: 0\n  }\n\n  to {\n      opacity: 1\n  }\n"]),
    ln = e.keyframes(an),
    sn = r.span(on, ln, function (n) {
  return tn[n.position];
}),
    cn = function cn(n) {
  var e = n.content,
      r = n.position,
      t = n.children,
      a = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["content", "position", "children"]);

  return e ? o.createElement(sn, Object.assign({}, {
    "aria-label": e,
    position: r
  }, a), t) : null;
};

cn.propTypes = {
  content: a.string,
  position: a.string,
  children: a.node
}, cn.defaultProps = {
  content: null,
  position: "top",
  children: null
};

var dn = Object.freeze(["\n  background-color: #f3f5f8;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--border-radius);\n  padding: 40px 20px;\n  text-align: center;\n\n  p {\n    font-size: 90%;\n  }\n"]),
    pn = r.div(dn),
    bn = function bn(n) {
  return o.createElement(pn, n);
};

bn.propTypes = {
  children: a.node
}, bn.defaultProps = {
  children: o.createElement("p", null, "Unfortunately there is currently nothing we can show you.")
};
var fn = Object.freeze(["\n    padding: ", ";\n  "]),
    un = Object.freeze(["\n  background-color: var(--bg-white);\n  border: 1px solid var(--border-gray);\n  border-radius: var(--border-radius);\n  padding: var(--spacer-3);\n\n  ", ";\n\n  > h2 {\n    margin-bottom: 2.5rem;\n  }\n\n  > h3 {\n    margin-top: 0;\n  }\n"]),
    gn = r(function (n) {
  var e = n.as;
  void 0 === e && (e = "div");

  var r = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["as", "spacing"]);

  return o.createElement(e, r);
})(un, E.small(fn, function (n) {
  return n.spacing;
}));
gn.propTypes = {
  spacing: a.string
}, gn.defaultProps = {
  spacing: "20px 40px"
};
var mn = Object.freeze(["\n  background-color: var(--bg-purple-light);\n  color: var(--text-purple);\n  border-radius: 2px;\n  font-size: 0.8rem;\n\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n  white-space: nowrap;\n\n  margin-right: 6px;\n  margin-bottom: 6px;\n  padding-left: 8px;\n  padding-right: 8px;\n"]),
    hn = r.span(mn),
    vn = Object.freeze(["\n  border-bottom: 1px solid var(--border-gray);\n  position: sticky;\n  top: 0;\n  z-index: 1;\n"]),
    xn = Object.freeze(["\n  background: none;\n  border: 0;\n  cursor: pointer;\n  padding: var(--spacer-3);\n  margin: calc(var(--spacer-3) * -1);\n\n  &:hover {\n    color: var(--text-blue);\n  }\n"]),
    zn = Object.freeze(["\n  background-color: white;\n  background-clip: padding-box;\n  border-color: #444d56;\n  box-shadow: 0 0 18px rgba(0, 0, 0, 0.4);\n  overflow: auto;\n\n  animation: ", " 225ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity;\n\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 999;\n  max-height: 80vh;\n  margin: 10vh auto;\n\n  width: 460px;\n  margin-right: auto;\n  margin-left: auto;\n"]),
    yn = Object.freeze(["\n  cursor: pointer;\n  display: inline-block;\n\n  &::-webkit-details-marker {\n    display: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n"]),
    wn = Object.freeze(["\n  &[open] > summary::before {\n    content: '';\n    cursor: default;\n    display: block;\n    background: rgba(27,31,35,0.5);\n\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n  }\n"]),
    On = Object.freeze(["\n    0% { opacity: 0; }\n  100% { opacity: 1; }\n"]),
    kn = e.keyframes(On),
    jn = r.details(wn);

function Cn(n) {
  n.target.closest("details").removeAttribute("open");
}

jn.Summary = r.summary(yn), jn.Dialog = r(g).attrs({
  role: "dialog",
  tabIndex: "-1"
})(zn, kn), jn.Dialog.CloseButton = r(function (n) {
  return o.createElement("button", Object.assign({}, {
    onClick: Cn
  }, n), o.createElement(W, {
    name: "close"
  }));
})(xn), jn.Dialog.Header = r(function (n) {
  var e = o.createElement(C, {
    element: "header",
    justifyContent: "space-between"
  }, n.children, o.createElement(jn.Dialog.CloseButton, null));
  return o.createElement(g.Header, n, e);
})(vn), jn.Dialog.Body = g.Body;
var Ln = Object.freeze(["\n  background-color: ", ";\n  height: 1px;\n  margin: 0;\n  border: none;\n  margin: ", " 0;\n"]),
    Mn = r(function (n) {
  var e = n.as;
  void 0 === e && (e = "hr");

  var r = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["as", "spacing", "color"]);

  return o.createElement(e, r);
})(Ln, function (n) {
  return n.color;
}, function (n) {
  return n.spacing;
});
Mn.propTypes = {
  spacing: a.string,
  color: a.string
}, Mn.defaultProps = {
  spacing: "20px",
  color: "var(--border-gray)"
};
var Hn = Object.freeze(['\n  position: relative;\n  display: block;\n  padding: 8px 10px;\n  margin-bottom: 5px;\n  overflow: hidden;\n  font-size: var(--font-size-medium);\n  color: var(--text-gray);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: pointer;\n  border-radius: var(--border-radius);\n\n  &:hover {\n    background-color: var(--bg-gray-dark);\n    text-decoration: none;\n  }\n\n  &[aria-current="page"] {\n    color: #fff;\n    background-color: var(--bg-blue);\n  }\n']),
    Tn = Object.freeze([""]),
    Vn = r.div(Tn);
Vn.Item = r.div(Hn);
var Sn = Object.freeze(['\n  :root {\n    --purple: #657cfb;\n    --blue: #0060ea;\n    --green: #56d9a0;\n    --red: #fc435b;\n\n    --text-white: #fff;\n    --text-black: #101421;\n    --text-blue: var(--blue);\n    --text-green: #56d9a0;\n    --text-red: var(--red);\n    --text-purple: var(--purple);\n    --text-gray: #858b99;\n    --text-gray-dark: #6C7280;\n\n    --bg-green: var(--green);\n    --bg-red: var(--red);\n    --bg-blue: var(--blue);\n    --bg-blue-light: #f3f7ff;\n    --bg-purple: var(--purple);\n    --bg-purple-light: #eff1ff;\n    --bg-gray: #f3f5f8;\n    --bg-gray-light: #fafbfc;\n    --bg-gray-dark: var(--border-gray);\n    --bg-white: #fff;\n\n    --border-gray: #e2e8f0;\n    --border-purple: var(--purple);\n    --border-blue: var(--blue);\n    --border-green: var(--green);\n\n    --spacer: 8px;\n    --spacer-0: 0;\n    --spacer-1: calc(var(--spacer) / 2);\n    --spacer-2: var(--spacer);\n    --spacer-3: calc(var(--spacer) * 2);\n    --spacer-4: calc(var(--spacer) * 3);\n    --spacer-5: calc(var(--spacer) * 4);\n    --spacer-6: calc(var(--spacer) * 5);\n\n    --border-radius: 3px;\n\n    --font-size-default: 16px;\n    --font-size-medium: 14px;\n    --font-size-small: 12px;\n\n    --font-weight-bold: 600;\n    --font-weight-semibold: 500;\n    --font-weight-normal: 400;\n    --font-weight-light: 300;\n\n    box-sizing: border-box;\n    color: var(--text-black);\n    font-family: "Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n    font-size: var(--font-size-default);\n    ', "\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    font-feature-settings: 'liga';\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n\n  body {\n    background-color: var(--bg-gray);\n    font-size: inherit;\n    margin: 0;\n  }\n\n  a {\n    color: var(--text-blue);\n    text-decoration: none;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  p {\n    ", "\n    margin-bottom: 10px;\n  }\n\n  blockquote {\n    border-left: 0.25em solid var(--border-gray);\n    color: var(--text-gray);\n    padding: 0 1em;\n    margin: 0;\n    margin-bottom: 16px;\n  }\n\n  input::placeholder,\n  select:invalid {\n    color: var(--text-gray);\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  svg {\n    vertical-align: bottom;\n  }\n\n  [disabled] {\n    pointer-events: none;\n    opacity: 0.6;\n    user-select: none;\n  }\n\n  details summary {\n    cursor: pointer;\n    display: inline-block;\n    &::-webkit-details-marker {\n      display: none;\n    }\n    &:focus {\n      outline: 0;\n    }\n  }\n"]),
    En = e.createGlobalStyle(Sn, "", "");
var In = Object.freeze(["\n  position: absolute;\n  left: var(--spacer);\n"]),
    Bn = Object.freeze(['\n  display: block;\n  padding: var(--spacer) var(--spacer) var(--spacer) 30px;\n  overflow: hidden;\n  color: inherit;\n  cursor: pointer;\n  border-bottom: 1px solid #e1e4e8;\n  position: relative;\n\n\n  &:hover {\n    color: var(--text-white);\n    background-color: var(--bg-blue);\n    text-decoration: none;\n  }\n\n  &[aria-checked="true"] {\n    font-weight: var(--font-weight-bold);\n  }\n']),
    Pn = Object.freeze(["\n  max-height: 400px;\n  overflow: auto;\n"]),
    Dn = Object.freeze(["\n  padding: var(--spacer) 10px;\n  background: var(--bg-gray);\n  border-bottom: 1px solid #e1e4e8;\n"]),
    Wn = Object.freeze(["\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(27, 31, 35, 0.15);\n  border-radius: var(--border-radius);\n  box-shadow: 0 3px 12px rgba(27, 31, 35, 0.15);\n\n  width: 300px;\n  margin-top: 4px;\n  margin-bottom: 20px;\n  overflow: hidden;\n\n  position: absolute;\n  right: 0;\n\n  text-align: left;\n  z-index: 1;\n"]),
    Rn = Object.freeze(['\n  display: inline-block;\n  position: relative;\n  font-size: var(--font-size-medium);\n\n  > summary {\n    cursor: pointer;\n  }\n\n  > summary:focus {\n    outline: 0;\n  }\n\n  /*  Remove marker added by Chrome */\n  > summary::-webkit-details-marker {\n    display: none;\n  }\n\n  /* arrow */\n  > summary::after {\n    border: 4px solid;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n    border-left-color: transparent;\n\n    content: "";\n    display: inline-block;\n    width: 0;\n    height: 0;\n    vertical-align: -2px;\n    margin-left: 5px;\n  }\n\n  /* Overlay to blur details */\n  &[open] > summary::before {\n    content: "";\n    cursor: default;\n    display: block;\n\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n']),
    Xn = r.details(Rn);
Xn.Modal = r.div.attrs({
  role: "menu"
})(Wn), Xn.Header = r.div(Dn), Xn.List = r.div(Pn), Xn.Item = r(function (n) {
  var e = n.as;
  void 0 === e && (e = "div");

  var r = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["as"]);

  return o.createElement(e, r);
})(Bn), Xn.Item.Icon = r(W)(In);

var An = Object.freeze(["\n  position: sticky;\n  ", "\n  ", "\n  ", "\n  ", "\n"]),
    Fn = r(function (n) {
  var e = n.as;
  void 0 === e && (e = "div");

  var r = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["as", "top", "right", "bottom", "left"]);

  return o.createElement(e, r);
})(An, function (n) {
  return n.top ? "top: " + n.top + ";" : "";
}, function (n) {
  return n.right ? "right: " + n.right + ";" : "";
}, function (n) {
  return n.bottom ? "right: " + n.bottom + ";" : "";
}, function (n) {
  return n.left ? "right: " + n.left + ";" : "";
}),
    qn = Object.freeze(['\n  appearance: none;\n  transition: 400ms all;\n  margin: 0 auto;\n  display: block;\n  border-radius: 40px;\n  background: var(--bg-gray);\n  box-shadow: inset 0 0 0 1px var(--border-gray);\n  width: 36px;\n  height: 14px;\n  outline: 0;\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n\n  &:checked {\n    background: var(--bg-green);\n    box-shadow: inset 0 0 0 15px var(--bg-green);\n    transition: 250ms all;\n  }\n\n  &::before {\n    content: "";\n    transition: 300ms all;\n    transform: translate(0, -3px);\n    display: block;\n    width: 20px;\n    height: 20px;\n    border-radius: 40px;\n    background: white;\n    box-shadow: inset 0 0 0 1px var(--border-gray);\n  }\n\n  &:checked::before {\n    transform: translate(16px, -3px);\n  }\n']),
    Gn = r.input.attrs({
  type: "checkbox"
})(qn),
    Un = Object.freeze(["\n    background-color: var(--bg-white);\n    border-color: var(--border-gray);\n    border-radius: var(--border-radius) var(--border-radius) 0 0;\n  "]),
    Nn = Object.freeze(["\n  border: 1px solid transparent;\n  border-bottom: 0;\n  cursor: pointer;\n  font-size: var(--font-size-medium);\n  display: inline-block;\n  padding: 8px 12px;\n  margin-bottom: -1px;\n\n  ", ";\n"]),
    _n = Object.freeze(["\n  border-bottom: 1px solid var(--border-gray);\n"]),
    Jn = r.div(_n);

Jn.Tab = r.div(Nn, function (n) {
  return n.selected && e.css(Un);
});
var Kn = Object.freeze(["\n  --size: 32px;\n\n  background-color: var(--bg-gray);\n  border: 2px solid #fff;\n  border-radius: 50%;\n  color: var(--text-gray-dark);\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  width: var(--size);\n  height: var(--size);\n\n  position: absolute;\n  right: calc(100% - var(--size));\n"]),
    Qn = Object.freeze(["\n  margin-bottom: var(--spacer-5);\n"]),
    Yn = Object.freeze(['\n  position: relative;\n  padding: var(--spacer-3);\n  padding-left: calc(32px + var(--spacer-3));\n\n  &::before {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: var(--spacer-3);\n    display: block;\n    width: 2px;\n    content: "";\n    background-color: var(--border-gray);\n  }\n']),
    Zn = r.div(Yn);
Zn.Item = r.div(Qn), Zn.ItemIcon = r.div(Kn), exports.Avatar = l, exports.Button = d, exports.Box = g, exports.Dropdown = O, exports.Flexbox = C, exports.FormGroup = M, exports.FormLabel = T, exports.Grid = P, exports.Icon = W, exports.LayoutContainer = F, exports.LoadingActivity = function (n) {
  var e = n.size;
  void 0 === e && (e = 28);

  var r = function (n, e) {
    var r = {};

    for (var t in n) {
      Object.prototype.hasOwnProperty.call(n, t) && -1 === e.indexOf(t) && (r[t] = n[t]);
    }

    return r;
  }(n, ["size"]);

  return o.createElement(C, {
    justifyContent: "center",
    alignItems: "center"
  }, o.createElement("svg", Object.assign({}, {
    width: e,
    height: e,
    viewBox: "0 0 28 28",
    fill: "var(--text-gray)",
    role: "img",
    "aria-label": "Loading…"
  }, r), o.createElement("g", {
    fillRule: "evenodd"
  }, o.createElement("circle", {
    cx: "4",
    cy: "14",
    r: "3"
  }, o.createElement("animate", {
    attributeName: "opacity",
    dur: "0.8s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.08"
  })), o.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "3"
  }, o.createElement("animate", {
    attributeName: "opacity",
    dur: "0.8s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.16"
  })), o.createElement("circle", {
    cx: "24",
    cy: "14",
    r: "3"
  }, o.createElement("animate", {
    attributeName: "opacity",
    dur: "0.8s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.32"
  })))));
}, exports.LoadingBar = N, exports.Notification = J, exports.Subnav = Y, exports.TextField = rn, exports.Tooltipped = cn, exports.Blankslate = bn, exports.Card = gn, exports.Chip = hn, exports.Details = jn, exports.Divider = Mn, exports.FilterList = Vn, exports.GlobalStyle = En, exports.SelectMenu = Xn, exports.Sticky = Fn, exports.Switch = Gn, exports.Tabnav = Jn, exports.Timeline = Zn, exports.breakpoint = E;